const MESSAGES_UPDATED = (state, messages) => {
  state.messages = messages;
};

export default {
  MESSAGES_UPDATED,
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js